// Mock data for ETERRNAL website

export const heroData = {
  tagline: "A sanctuary for the spirit",
  headline: "Return to who you truly are",
  description: "For those who feel stuck, drained, or seeking clarity — this is a space to release what no longer serves you and reconnect with your natural state of balance and flow.",
  ctaText: "Book a Digital and Intuitive Energy Scanning",
  whatsappNumber: "+919109114371",
  whatsappMessage: "Hello, I would like to book a Digital and Intuitive Energy Scanning and seek guidance.",
  heroImage: "https://images.unsplash.com/photo-1737053569072-aad91e784431"
};

export const aboutEterrnal = {
  title: "About ETERRNAL",
  subtitle: "A space for energetic alignment",
  paragraphs: [
    "ETERRNAL is a spiritual wellness sanctuary created to help individuals release negative energies, break through energetic blockages, and restore clarity to their lives.",
    "Through the ancient wisdom of crystal healing and energy work, we guide you toward improved focus, abundance, and an elevated quality of life.",
    "This is not about quick fixes or surface-level change. It is about deep, lasting transformation — the kind that happens when you align your energy with your true purpose."
  ],
  image: "https://images.unsplash.com/photo-1764022276232-6fb9a464a7ae"
};

export const aboutFounder = {
  title: "Dr. Achira Sanyal",
  subtitle: "Founder & Crystal Healing Guide",
  paragraphs: [
    "Dr. Achira Sanyal's journey into spiritual wellness was not accidental. It was forged through years of discipline, inner work, and a deep commitment to understanding the subtle energies that shape our lives.",
    "What began as personal exploration evolved into mastery. Today, she stands as a trusted crystal healing guru — someone who has walked the path and now guides others with quiet authority and genuine care.",
    "Her approach is grounded, honest, and deeply intuitive. She doesn't promise miracles. She offers presence, clarity, and the tools to help you elevate your own life."
  ],
  image: "https://customer-assets.emergentagent.com/job_energy-balance-10/artifacts/v23fyk6u_outfit-swap-preview-1768311592358.png"
};

export const missionVision = {
  mission: {
    title: "Our Mission",
    description: "To help people align energetically and live with balance, awareness, and inner peace. We believe that when your energy flows freely, your life flows freely."
  },
  vision: {
    title: "Our Vision",
    description: "To support elevated, protected, and conscious living — creating a world where individuals are empowered to heal themselves and live in harmony with their true nature."
  }
};

export const energyScanning = {
  title: "Digital and Intuitive Energy Scanning",
  subtitle: "Understanding your energetic blueprint",
  description: "Our digital energy scanning process offers insight into your current energetic state — helping you understand imbalances and receive personalized guidance for your healing journey.",
  process: [
    {
      step: "1",
      title: "Share Your Photo",
      description: "A recent photograph with a plain background allows her to read your energy field clearly."
    },
    {
      step: "2",
      title: "Energy Analysis",
      description: "Using intuitive methods and crystal wisdom, Dr. Achira Sanyal analyzes your energetic patterns and blockages."
    },
    {
      step: "3",
      title: "Personalized Guidance",
      description: "Receive clear recommendations and guidance tailored to your unique energetic needs."
    }
  ],
  image: "https://images.unsplash.com/photo-1760651691839-d089c1d9ff54"
};

export const crystalCombinations = {
  title: "Crystal Combinations Designed for Your Unique Energy",
  description: "Each crystal solution is carefully crafted based on your individual energy scan. These are not generic recommendations—they are personalized combinations chosen specifically to address your energetic imbalances and support your spiritual growth.",
  features: [
    {
      title: "Energetically Attuned",
      description: "Each crystal is selected based on its unique vibrational properties to align with your specific energetic needs."
    },
    {
      title: "Guided Implementation",
      description: "You receive clear guidance on how to work with your crystal combinations for maximum benefit and transformation."
    },
    {
      title: "Ongoing Support",
      description: "You can continue to connect with Dr. Achira Sanyal for guidance as your energy evolves and shifts over time."
    }
  ],
  image: "https://customer-assets.emergentagent.com/job_energy-balance-10/artifacts/u12o2iv5_Untitled%20design%20%2838%29.png"
};

export const bookingInfo = {
  title: "How to Book",
  subtitle: "Simple, direct, and personal",
  steps: [
    "Click 'Book Appointment' to open WhatsApp",
    "Share a recent photo (plain background preferred)",
    "Share your ₹600 payment screenshot",
    "Receive your personalized energy scanning and guidance"
  ],
  price: "₹600",
  note: "This fee covers your energy scanning and personalized recommendations.",
  qrCodeImage: "https://customer-assets.emergentagent.com/job_energy-balance-10/artifacts/txxd21fd_QR%20CODE.pdf",
  upiId: "334852807067770@cnrb"
};

export const disclaimer = {
  title: "Important Notice",
  text: "The services offered by ETERRNAL are spiritual and energetic in nature. They are intended for personal growth and self-awareness and are not a substitute for professional medical, psychological, or psychiatric treatment. Please consult appropriate healthcare professionals for any medical concerns."
};

export const navigation = {
  logo: "ETERRNAL",
  logoImage: "https://customer-assets.emergentagent.com/job_energy-balance-10/artifacts/spmz4bit_ECHS%20LOGO.png",
  links: [
    { label: "About", href: "#about" },
    { label: "Dr. Achira Sanyal", href: "#founder" },
    { label: "Energy Scanning", href: "#scanning" },
    { label: "Book Now", href: "#booking" }
  ],
  whatsappNumber: "+919109114371",
  whatsappMessage: "Hello, I would like to book a Digital and Intuitive Energy Scanning and seek guidance."
};

export const footer = {
  logo: "ETERRNAL",
  logoImage: "https://customer-assets.emergentagent.com/job_energy-balance-10/artifacts/spmz4bit_ECHS%20LOGO.png",
  tagline: "A sanctuary for spiritual wellness and energetic alignment.",
  links: [
    { label: "About ETERRNAL", href: "#about" },
    { label: "Dr. Achira Sanyal", href: "#founder" },
    { label: "Energy Scanning", href: "#scanning" },
    { label: "How to Book", href: "#booking" }
  ],
  contact: {
    whatsapp: "+91 9109114371",
    whatsappLink: "https://wa.me/919109114371?text=Hello%2C%20I%20would%20like%20to%20book%20a%20Digital%20and%20Intuitive%20Energy%20Scanning%20and%20seek%20guidance."
  },
  copyright: "© 2026 ETERRNAL. All rights reserved."
};
